<twc-popup #popup caption="{{'JOB_SITE.DELETE.TITLE' | translate}}" type="primary" width="s">

    <twc-popup-content class="twc-mb-3">
        <div [innerHTML]="'JOB_SITE.DELETE.DESCRIPTION' | translate : {jobSite:jobSite.name}"></div>
        <form [formGroup]="deleteJobSiteForm">
            <twc-checkbox *ngFor="let key of formOptionKeys" [ngClass]="{'twc-ml-4': isChildItem(key)}">
                <input twcCheckboxInput type="checkbox" [formControlName]="key">
                <label twcCheckboxLabel>{{ deleteJobSiteLabels[key] | translate }}</label>
            </twc-checkbox>
        </form>
    </twc-popup-content>

    <twc-popup-footer>
        <button class="twc-button twc-button-link" (click)="popup.onClose()">
            {{'GENERAL.CANCEL' | translate}}</button>
        <button class="twc-button twc-ml-2 twc-button-primary" (click)="deleteJobSite()" [twcLoading]="isLoading"
            [disabled]="isLoading">
            {{'GENERAL.DELETE' | translate}}
        </button>
    </twc-popup-footer>
</twc-popup>